<template>
    <Loading :progress="10" v-if="showLoading" />
    <div class="page">
        <div class="back">
            <div style="display: inline-block;" @click="router.go(-1)">
                <img :src="back" alt="back">
                <span>{{t('common.back')}}</span>
            </div>
        </div>
        <div class="list">
            <div class="list-item">
                <div class="lable">
                    <div class="describe" style="font-size: 14px;">Topic(Task 2)</div>
                    <div class="describe" style="font-size: 14px;">大作文题目</div>
                </div>
                <div class="content">
                    <img class="left" :src="left" alt="">
                    <span style="white-space: pre-wrap;font-size: 14px;">
                    <h1 style="font-size: 14px;">
                        Some people think that media violence should be banned to reduce crimes. To what extent do
                        you agree or disagree with this opinion?
                    </h1>
                    </span>
                </div>
            </div>
            <div class="list-item active">
                <div class="lable">
                    <div class="rate">5.5</div>
                    <div class="describe" style="font-size: 14px;">Overall Score</div>
                    <div class="describe" style="font-size: 14px;">总分</div>
                </div>
                <div class="content">
                    <img class="left" :src="left" alt="">
                    <span style="white-space: pre-wrap;font-size: 14px;">
                    {{ originalContent }}
                    </span>
                </div>
            </div>
            <div class="list-item active">
                <div class="lable">
                    <div class="rate">5.5</div>
                    <div class="describe">Task Response</div>
                </div>
                <div class="content">
                    <img class="left" :src="left" alt="">
                    <span style="white-space: pre-wrap;font-size: 14px;">
            The essay addresses the prompt, but it lacks a clear and detailed argument. The points are somewhat general and could be more specific and well-developed. (文章虽然回答了题目，但论点不够明确和详细。提出的观点有些泛泛，可以更具体和深入一些。)
          </span>
                </div>
            </div>
            <div class="list-item">
                <div class="lable">
                    <div class="rate">5.0</div>
                    <div class="describe">Coherence and Cohesion</div>
                </div>
                <div class="content">
                    <img class="left" :src="left" alt="">
                    <span style="white-space: pre-wrap;font-size: 14px;">
                    The essay has a basic structure, but the transitions between ideas are not always smooth. Some sentences are disjointed, and the flow of the argument could be improved. (文章有基本的结构，但观点之间的过渡不够流畅。有些句子显得不连贯，论证的流畅性可以提高。)
                  </span>
                </div>
            </div>
            <div class="list-item">
                <div class="lable">
                    <div class="rate">5.5</div>
                    <div class="describe">Lexical Resource</div>
                </div>
                <div class="content">
                    <img class="left" :src="left" alt="">
                    <span style="white-space: pre-wrap;font-size: 14px;">
            The vocabulary used is adequate but limited. There is a lack of variety in the choice of words, and some expressions are repetitive. (使用的词汇足够但有限，缺乏多样性，有些表达重复。)
          </span>
                </div>
            </div>
            <div class="list-item">
                <div class="lable">
                    <div class="rate">5.0</div>
                    <div class="describe">Grammatical Range & Accuracy</div>
                </div>
                <div class="content">
                    <img class="left" :src="left" alt="">
                    <span style="white-space: pre-wrap;font-size: 14px;">
            There are several grammatical errors, including subject-verb agreement, tense consistency, and sentence structure. These errors affect the clarity and coherence of the essay. (存在一些语法错误，包括主谓一致、时态一致和句子结构问题。这些错误影响了文章的清晰度和连贯性。)
          </span>
                </div>
            </div>
            <div class="list-item">
                <div class="lable">
                    <div class="rate">up to 6.0</div>
                    <div class="describe">Natural Rewriting</div>
                    <div style="color: #ff5733;cursor: pointer;" @click="showCompare = true">原文对比</div>
                </div>
                <div class="content">
                    <img class="left" :src="left" alt="">
                    <span style="white-space: pre-wrap;font-size: 14px;">
                        {{rewriting}}
                    </span>
                </div>
            </div>
            <div class="list-item">
                <div class="lable">
<!--                              <div class="rate">5.5</div>-->
                    <div class="describe" style="white-space: pre-wrap;font-size: 14px;">词汇提升</div>
                    <div class="describe" style="white-space: pre-wrap;font-size: 14px;">Vocabulary Enhancement</div>
                </div>
                <div class="content">
                    <img class="left" :src="left" alt="">
                    <span style="white-space: pre-wrap;font-size: 14px;">
                         "easy access" --> "unrestricted access (无限制访问)",<br/>
                         "violent abuse" --> "violent behavior (暴力行为)",<br/>
                         "significant illegal activities" --> "serious criminal activities (严重犯罪活动)",<br/>
                         "discipline" --> "maturity (成熟)",<br/>
                         "high-pressure environment" --> "stressful work environment (高压工作环境)",<br/>
                         "ruining his family" --> "destroying his family (毁掉他的家庭)",<br/>
                         "interesting media" --> "engaging media (吸引人的媒体)",<br/>
                         "good barrier" --> "effective barrier (有效屏障)",<br/>
                    </span>
                </div>
            </div>
            <div class="list-item">
                <div class="lable">
                    <div class="describe" style="white-space: pre-wrap;font-size: 14px;">Correct Essay</div>
                    <div class="describe" style="white-space: pre-wrap;font-size: 14px;">原文修正</div>
                </div>
                <div class="content">
                    <img class="left" :src="left" alt="">
                    <span style="white-space: pre-wrap;font-size: 14px;">
                        {{correctEssay}}
                    </span>
                </div>
            </div>

            <div class="list-item" >
                <div class="lable">
                    <div class="describe" style="font-size: 14px;">Grammar Correction</div>
                    <div class="describe" style="font-size: 14px;">语法修正</div>
                </div>
                <div class="content">
                    <img class="left" :src="left" alt="">
                    <span style="font-size: 14px;white-space: pre-wrap;">
                        "The debate on whether the rate of crime can be decreased by stopping to play videos with violence on the internet."<br/>
                        "The debate on whether the rate of crime can be decreased by banning violent videos on the internet. (将 'stopping to play' 改为 'banning' 使句子更简洁明了。)",<br/><br/>

                        "if everyone is able to access some medium that includes violence easily without supervision, it could cause violent abuse, especially among young adults because it is a very important period for developing their mental and physical health."<br/>
                         "if young people have easy access to violent media without supervision, it can lead to harmful consequences. This is a critical period for their mental and physical development. (将 'everyone' 改为 'young people' 更具体，并简化句子结构。)",<br/><br/>

                         "Media violence might lead teenagers to imitate some scenes from videos to steal or engage in other significant illegal activities and even stay in jail for a few years."<br/>
                         "Exposure to violent content might encourage them to imitate such behavior, leading to illegal activities and even imprisonment. (将 'media violence' 改为 'exposure to violent content' 使句子更自然，并简化句子结构。)",<br/><br/>

                         "So young people should be banned from watching them until they have discipline."<br/>
                         "So young people should be restricted from accessing such content until they reach maturity. (将 'banned from watching' 改为 'restricted from accessing' 并将 'have discipline' 改为 'reach maturity' 使句子更准确。)",<br/><br/>

                         "Some people who are over particular ages should enjoy media violence because they have built their personalities so that sometimes they can release their pressure by games or movies from Google searching."<br/>
                         "Adults who have already developed their personalities may benefit from media violence as a way to relieve stress. (将 'some people who are over particular ages' 改为 'adults who have already developed their personalities' 使句子更具体，并简化句子结构。)",<br/><br/>

                         "Such as a mature person who likes to play games and works in a high-pressure environment, violent games might be a better choice for reducing their pressure rather than one day he might be breaking the law then ruining his family."<br/>
                         "For example, a mature individual working in a stressful work environment might find that playing violent games helps them manage their stress better than engaging in illegal activities. (将 'such as' 改为 'for example' 并简化句子结构。)",<br/><br/>

                         "So people should choose their interesting media even if media violence to relax themselves."<br/>
                         "So people should be allowed to choose engaging media, even if it includes violent content, to relax themselves. (将 'choose their interesting media' 改为 'be allowed to choose engaging media' 并添加 'even if it includes violent content' 使句子更完整。)",<br/><br/>

                         "In conclusion, a good barrier is a better method to split the different ranges of the ages of people enjoying their own medium in order to prevent crimes from happening."<br/>
                         "In conclusion, an effective barrier to separate different age groups in accessing media violence is a better method to prevent crimes. (将 'a good barrier' 改为 'an effective barrier' 并简化句子结构。)",<br/><br/>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <el-dialog v-model="showCompare" title="原文对比" width="80%">
        <div>比较方式:
            <el-radio v-model="comparisonModel" label="line-by-line" checked >行比较</el-radio>
            <el-radio v-model="comparisonModel" label="side-by-side" >段落比较</el-radio>
        </div>
        <div class="u-flex">
            <div class="u-flex-1" style="margin-right: 40px;white-space: pre-wrap;font-size: 14px;">
                <!--        {{ form?.essay?.content }}-->
                <code-diff
                        class="center"
                        :renderNothingWhenEmpty=true
                        :old-string="originalContent"
                        :new-string="rewriting"
                        :context="10"
                        :outputFormat="comparisonModel"
                        :forceInlineComparison=true
                        :hideHeader=true
                        :hideStat=true
                />
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
    import back from '../assets/list/back.png'
    import left from '../assets/list/left.png'
    import up from '../assets/list/up.png'
    import Loading from '../components/Loading.vue'
    import { CodeDiff } from 'v-code-diff';
    import i18n from '../locale/i18n';
    import { useHead } from '@vueuse/head';
    import { useRouter, useRoute } from 'vue-router';

    const router = useRouter();
    const comparisonModel = ref('line-by-line');
    const t = (key) => i18n.global.t(key);

    useHead({
      htmlAttrs: {
        lang: t("common.lang") // 动态设置 lang 属性
      },
      title: "Some people think that media violence should be banned to reduce crimes. To what extent do you agree"+
            "or disagree with this opinion? - "+ t("metaSample55.title"),
      meta: [
        { name: 'description', content: t("metaSample55.description") },
        { name: 'keywords', content: t("metaSample55.keywords") }
      ]
    });

    const showLoading = ref(false)
    const showCompare = ref(false)

    const originalContent = ref('The debate on whether the rate of crime can be decreased by stopping to play videos with violence on the internet. In my opinion, whether media violence should be banned depends on the age of the viewer or the player.\n\n'+
        'On the one hand, if everyone is able to access some medium that includes violence easily without supervision, itcould cause violent abuse, especially among young adults because it is a very important period for developing their mental and physical health. Media violence might lead teenagers to imitate some scenes from videos to steal or engage in other significant illegal activities and even stay in jail for a few years. So young people should  be banned from watching them until they have discipline.\n\n'+
        'On the other hand, some people who are over particular ages should enjoy media violence because they have builttheir personalities so that sometimes they can release their pressure by games or movies from Google searching. Such as a mature person who likes to play games and works in a high-pressure environment, violent games might be a better choice for reducing their pressure rather than one day he might be breaking the law then ruining his family. So people should choose their interesting media even if media violence to relax themself.\n\n'+
        'In conclusion, a good barrier is a better method to split the different ranges of the ages of people enjoyingtheir own medium in order to prevent crimes from happening.\n\n'+
    '');
    const rewriting = ref('The debate on whether media violence should be banned to reduce crime is a contentious one. In my opinion, the decision to ban media violence should depend on the age of the viewer or player. (讨论是否应该禁止媒体暴力以减少犯罪是一个有争议的话题。在我看来，是否禁止媒体暴力应取决于观众或玩家的年龄。)\n\n'+
        'On the one hand, if young people have easy access to violent media without supervision, it can lead to harmful consequences. This is a critical period for their mental and physical development, and exposure to violent content might encourage them to imitate such behavior, leading to illegal activities and even imprisonment. (一方面，如果年轻人在没有监督的情况下容易接触到暴力媒体，可能会导致有害后果。这是他们身心发展的重要时期，接触暴力内容可能会促使他们模仿这种行为，从而导致非法活动甚至入狱。)\n\n'+
        'On the other hand, adults who have already developed their personalities may benefit from media violence as a way to relieve stress. For example, a mature individual working in a high-pressure environment might find that playing violent games helps them manage their stress better than engaging in illegal activities. (另一方面，已经形成个性的成年人可能通过媒体暴力来缓解压力。例如，一个在高压环境下工作的成熟人士可能会发现玩暴力游戏比从事非法活动更能帮助他们管理压力。)\n\n'+
        'In conclusion, a good barrier to separate different age groups in accessing media violence is a better method to prevent crimes. (总之，设置一个良好的屏障来区分不同年龄段的人接触媒体暴力是一种更好的预防犯罪的方法。)\n\n');
    const correctEssay = ref('The debate on whether the rate of crime can be decreased by stopping to play videos with violence on the internet. (关于是否可以通过停止播放互联网上的暴力视频来降低犯罪率的辩论。) (改为: The debate on whether the rate of crime can be decreased by banning violent videos on the internet. (关于是否可以通过禁止互联网上的暴力视频来降低犯罪率的辩论。))\n\n'+
        'In my opinion, whether media violence should be banned depends on the age of the viewer or the player. (在我看来，是否应该禁止媒体暴力取决于观众或玩家的年龄。) (改为: In my opinion, the decision to ban media violence should depend on the age of the viewer or the player. (在我看来，是否禁止媒体暴力应取决于观众或玩家的年龄。))\n\n'+
        'On the one hand, if everyone is able to access some medium that includes violence easily without supervision, it could cause violent abuse, especially among young adults because it is a very important period for developing their mental and physical health. (一方面，如果每个人都能轻松地在没有监督的情况下接触到包含暴力的媒介，这可能会导致暴力行为，尤其是在年轻人中，因为这是他们身心发展的重要时期。) (改为: On the one hand, if young people have easy access to violent media without supervision, it can lead to harmful consequences. This is a critical period for their mental and physical development. (一方面，如果年轻人在没有监督的情况下容易接触到暴力媒体，可能会导致有害后果。这是他们身心发展的重要时期。))\n\n'+
        'Media violence might lead teenagers to imitate some scenes from videos to steal or engage in other significant illegal activities and even stay in jail for a few years. (媒体暴力可能会导致青少年模仿视频中的某些场景进行盗窃或其他重大非法活动，甚至坐牢几年。) (改为: Exposure to violent content might encourage them to imitate such behavior, leading to illegal activities and even imprisonment. (接触暴力内容可能会促使他们模仿这种行为，从而导致非法活动甚至入狱。))\n\n'+
        'So young people should be banned from watching them until they have discipline. (所以年轻人应该被禁止观看这些内容，直到他们成熟。) (改为: So young people should be restricted from accessing such content until they reach maturity. (所以年轻人应该被限制接触这些内容，直到他们成熟。))\n\n'+
        'On the other hand, some people who are over particular ages should enjoy media violence because they have built their personalities so that sometimes they can release their pressure by games or movies from Google searching. (另一方面，一些超过特定年龄的人应该享受媒体暴力，因为他们已经形成了自己的个性，有时可以通过从谷歌搜索的游戏或电影来释放压力。) (改为: On the other hand, adults who have already developed their personalities may benefit from media violence as a way to relieve stress. (另一方面，已经形成个性的成年人可能通过媒体暴力来缓解压力。))\n\n'+
        'Such as a mature person who likes to play games and works in a high-pressure environment, violent games might be a better choice for reducing their pressure rather than one day he might be breaking the law then ruining his family. (例如，一个喜欢玩游戏并在高压环境下工作的成熟人士，暴力游戏可能是减轻压力的更好选择，而不是有一天他可能会违法然后毁掉他的家庭。) (改为: For example, a mature individual working in a stressful work environment might find that playing violent games helps them manage their stress better than engaging in illegal activities. (例如，一个在高压环境下工作的成熟人士可能会发现玩暴力游戏比从事非法活动更能帮助他们管理压力。))\n\n'+
        'So people should choose their engaging media even if media violence to relax themselves. (所以人们应该选择他们感兴趣的媒体，即使是有暴力内容的媒体来放松自己。) (改为: So people should be allowed to choose engaging media, even if it includes violent content, to relax themselves. (所以人们应该被允许选择吸引他们的媒体，即使它包含暴力内容，来放松自己。))\n\n'+
        'In conclusion, a good barrier is a better method to split the different ranges of the ages of people enjoying their own medium in order to prevent crimes from happening. (总之，设置一个良好的屏障来区分不同年龄段的人接触媒体暴力是一种更好的预防犯罪的方法。) (改为: In conclusion, an effective barrier to separate different age groups in accessing media violence is a better method to prevent crimes. (总之，设置一个有效的屏障来区分不同年龄段的人接触媒体暴力是一种更好的预防犯罪的方法。))\n\n'+
    '')
</script>

<style lang="less" scoped>
    .page {
      width: 78.125vw;
      height: 100%;
      margin: 0 auto;
      padding: 25px;
      .back {
        height: 2.92vw;
        line-height: 2.92vw;
        text-align: right;
        cursor: pointer;
        img {
          width: 1.04vw;
          height: auto;
          margin-right: 0.677vw;
        }
        span {
          vertical-align: middle;
          font-size: 0.73vw;
          color: rgba(0, 0, 0, 1);
        }
      }
      .list {
        .list-item {
          margin-bottom: 1.45vw;
          display: flex;
          align-items: flex-start;
          .lable {
            margin-right: 1.51vw;
            position: relative;
            width: 11.93vw;
            height: 5.89vw;
            border-radius: 0.52vw;
            background: rgba(255, 255, 255, 1);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .rate {
              font-size: 2.08vw;
              color: rgba(56, 112, 255, 1);
            }
            .describe {
              font-size: 0.83vw;
              color: rgba(51, 51, 51, 1);
            }
          }
          .content {
            flex: 1;
            min-height: 5.89vw;
            border-radius: 0.52vw;
            background: rgba(255, 255, 255, 1);
            position: relative;
            padding: 1.3vw 2.3vw;
            .left {
              position: absolute;
              width: 1.25vw;
              height: 1.25vw;
              top: 2.32vw;
              left: -1.25vw;
            }
            span {
              line-height: 1.5;
              font-size: 0.83vw;
              font-weight: 500;
              color: rgba(0, 0, 0, 1);
            }
          }
        }
        .active {
          .lable {
            background: rgba(56, 112, 255, 1);
            .rate,
            .describe {
              color: rgba(255, 255, 255, 1);
            }
          }
        }
      }
    }
</style>
